module.exports = __webpack_public_path__ + "static/w-widi-df6a299a0a20b0344fa3a0040d857b34.jpeg";